/* @jsx h */
import { CustomerCheckout } from "@lemmonhq/types";
import { defineComponent, h } from "vue";

import {} from "./components";
import { useMenu } from "../../providers";
import { RouterLink } from "vue-router";
import { useLocalization } from "@lemmonhq/uikit";

export const SingleCheckoutStatus = defineComponent<{
  checkout: CustomerCheckout;
  // payment?: PaymentDetails;
}>({
  props: [
    "checkout",
    //"payment"
  ],
  setup(props) {
    const { shop } = useMenu();
    const { t } = useLocalization();

    return () => {
      return (
        <div class="container mx-auto p-4 max-w-2xl flex-1 h-full flex justify-center items-center flex-col">
          <div class="flex gap-4 flex-col items-center justify-center p-8 text-center">
            <div class="">
              <span class="material-symbols-outlined text-6xl text-gray-400">
                shopping_cart
              </span>
            </div>
            <div class="text-center">
              <div class="text-2xl font-medium text-accent">
                {t("customer.checkout_status.loading")}
              </div>
              <div class="text-sm text-base-content/50 mt-2">
                {t("customer.checkout_status.processing_request")}
              </div>
            </div>
            <RouterLink
              to={`/restaurant/${shop.value?.slug || ""}`}
              class="btn btn-primary hidden"
            >
              <span class="material-symbols-outlined mr-2">restaurant</span>
              {t("customer.checkout_status.browse_menu")}
            </RouterLink>
          </div>
        </div>
      );
    };
  },
});
